var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#1A1A1A"},[React.createElement("path",{"d":"M17.2 2.9c-.2-.1-.5-.1-.7.2-.1.2-.1.5.2.7 3 1.7 4.8 4.9 4.8 8.3 0 5.2-4.3 9.5-9.5 9.5S2.5 17.2 2.5 12c0-5.2 4.3-9.5 9.5-9.5.6 0 1.1.1 1.7.2.3 0 .5-.1.6-.4 0-.3-.1-.5-.4-.6-.6-.1-1.3-.2-1.9-.2C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12c0-3.8-2-7.3-5.3-9.1Z","key":0}),React.createElement("path",{"d":"M12 18.3c.3 0 .5-.2.5-.5V10c0-.3-.2-.5-.5-.5s-.5.2-.5.5v7.8c0 .2.2.5.5.5ZM11.6 7.3s.1.1.2.1h.4c.1 0 .1-.1.2-.1 0 0 .1-.2.1-.3v-.2c0-.1-.1-.1-.1-.2 0 0-.1-.1-.2-.1h-.4c-.1 0-.1.1-.2.1 0 .1-.1.3-.1.4v.2c.1 0 .1.1.1.1Z","key":1})]));
}

Info.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Info;

Info.default = Info;
